import { render } from "./SidePanel.vue?vue&type=template&id=7b0167e2&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=7b0167e2&scoped=true&lang=scss"
import "./SidePanel.vue?vue&type=style&index=1&id=7b0167e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0167e2"],['__file',"src/components/help/SidePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b0167e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b0167e2', __exports__)) {
    api.reload('7b0167e2', __exports__)
  }
  
  module.hot.accept("./SidePanel.vue?vue&type=template&id=7b0167e2&scoped=true", () => {
    api.rerender('7b0167e2', render)
  })

}


export default __exports__